import lazyLoadImages from "./components/lazyLoad";

export default class Cart {
    init = async () => {
        document.querySelector('.empty-the-cart')?.addEventListener('click', this.emptyTheCart);
        document.querySelector('.share-cart')?.addEventListener('click', this.shareUrl)
    }

    emptyTheCart = async () => {
        try {
            document.querySelector('.empty-the-cart')?.classList.add('loading')
            const res = await fetch(wc_add_to_cart_params.ajax_url + '?action=empty_the_cart');
            const data = await res.json();

            if (data.success) {
                const updateCartBtn = document.querySelector('button[name="update_cart"]');
                if (updateCartBtn) {
                    updateCartBtn.removeAttribute('disabled')
                    updateCartBtn.click();
                }
            }
            document.querySelector('.empty-the-cart')?.classList.remove('loading')

        } catch (e: any) {
            console.error(e);
        }
    }

    shareUrl = async () => {
        try {
            document.querySelector('.share-cart')?.classList.add('loading')
            document.querySelector('.share-url')?.remove()
            const formData = new FormData();
            formData.append('action', 'share_cart');

            const res = await fetch(window.app_extra.ajaxUrl, {
                method: 'POST',
                body: formData,
            });

            const data = await res.json();

            document.querySelector('.share-cart')?.classList.remove('loading')

            const messageBox = document.createElement('div') as HTMLDivElement;
            const copyUrl = document.createElement('div') as HTMLDivElement;
            const copyTitle = document.createElement('h2') as HTMLHeadingElement;
            const successMessage = document.createElement('div') as HTMLDivElement;
            const codeWrapper = document.createElement('div') as HTMLDivElement;


            copyTitle.textContent = 'Udostępnij koszyk'

            copyUrl.dataset.copy = data.data.url;
            copyUrl.textContent = 'Skopiuj'
            copyUrl.classList.add('copy-share')
            codeWrapper.classList.add('share-code')

            messageBox.classList.add('share-url')
            codeWrapper.textContent = data.data.url;
            successMessage.classList.add('share-url-content')
            messageBox.append(copyTitle);
            messageBox.append(successMessage);
            successMessage.append(codeWrapper);
            successMessage.append(copyUrl);

            document.querySelector('.cart-container')?.parentNode?.prepend(messageBox);

            copyUrl.addEventListener("click", () => {
                const toCopy = copyUrl.dataset.copy;
                if (toCopy) {
                    navigator.clipboard.writeText(toCopy);
                }
                copyUrl.textContent = 'Skopiowano'

                setTimeout(() => {
                    copyUrl.textContent = 'Skopiuj'
                }, 1000)
            });

        } catch (e: any) {
            console.error(e);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Cart().init();
    jQuery(document).on("ajaxComplete", lazyLoadImages);

});